import { Theme } from "@mui/material/styles";
import { getColors } from "../../utils";
import { DARK } from "../../constants";
export const DISPLAY_LARGE = "mb-0 align-self-center d-none d-xl-block";
export const DISPLAY_SMALL = "d-block d-xl-none";

export const infoBarMobileWrapper = {
  width: "100%",
  display: "flex",
  flexDirection: "column" as const,
};

export const infoBarMobileDropdown = (theme: Theme) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column" as const,
  backgroundColor: (theme.palette as any).custom?.customColor,
});
export const infoBarMobileStyles = (theme: Theme) => ({
  headerTop: {
    display: "flex",
    height: "72px",
    padding: "var(--Spacing-Spacing-8, 8px) 16px 8px 16px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
  },
  headerBottom: {
    display: "flex",
    height: "48px",
    padding: "var(--Spacing-Spacing-8, 8px) 16px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
    backgroundColor:
      theme.palette.mode === DARK
        ? getColors().surfaceSecondary
        : theme.palette.primary.light,
    color: getColors().text,
  },

  addressBlock: {
    display: "flex",
    height: "36px",
    padding: "var(--Spacing-Spacing-8, 8px) var(--Spacing-Spacing-0, 0)",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  typo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  menu: {
    width: 44,
    height: 40,
    backgroundColor: getColors().surfaceSecondary,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  shopCartcontainer: {
    display: "flex",
    padding: "0px 16px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
  },
  shopCart: {
    display: "flex",
    height: "40px",
    maxWidth: "336.02px",
    padding: "var(--Spacing-Spacing-8, 8px)",
    alignItems: "center",
    gap: "-6px",
    cursor: "pointer",
  },
  address: {
    display: "flex",
    width: "200px",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
  },
  bottomBlock: {
    cursor: "pointer",
    display: "flex",
    padding: "8px 0px",
    alignItems: "center",
    gap: "16px",
    width: "100%",
  },

  shopName: {
    maxWidth: "180px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  mobileTextBlock: {
    display: "flex!important",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    color: getColors().text,
  },
});
export const infoBarDesktopStyles = (theme: Theme) => ({
  authButtons: {
    display: "flex",
    gap: 32,
    alignItems: "center",
  },

  clickable: {
    cursor: "pointer",
  },

  dropdownWrapper: {
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center",
    color: theme.palette.text.primary,
  },
  hrStyle: {
    backgroundColor: theme.palette.background.paper,
    borderBottom: getColors().border,
  },
  headerStyle: {
    height: 80,
    py: "18px",
    px: {
      lg: "40px",
      md: "32px",
      sm: "32px",
    },
    gap: {
      lg: "40px",
      md: "40px",
      sm: "10px",
    },
  },

  textBlock: {
    marginLeft: "16px",
    marginRight: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "4px",
  },

  rightBlock: {
    display: "flex",
    alignItems: "center",
  },
  addressBlock: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
    cursor: "pointer",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  typo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    letterSpacing: "-0.42px",
  },
  tagBlock: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
    cursor: "pointer",
    color: getColors().text,
  },
});
export const detailsStyle = (theme: Theme) => ({
  leftStyle: {
    display: "flex",
    alignItems: "center",
    "@media (min-width: 1200px)": {
      width: "340px!important",
    },
  },

  centerStyle: {
    display: "flex",
    minWidth: "380px",
    padding: "2px 16px 2px 2px",
    alignItems: "center",
    gap: "var(--Spacing-Spacing-16, 16px)",
    flex: "1 0 0",
    borderRadius: "var(--Corner-Radius-Rounded, 999px)",
    border: theme.palette.mode === "dark" ? "none" : getColors().border,
    background:
      theme.palette.mode === "dark"
        ? getColors().surfaceSecondary
        : getColors().bglightgrey,
    color: theme.palette.text.primary,
  },

  rightStyle: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
    alignSelf: "stretch",
    width: "340px",
    justifyContent: "flex-end",
  },
});
export const dropdown = {
  display: "flex",
  padding: "8px var(--Spacing-Spacing-12, 12px)",
  alignItems: "center",
  gap: "var(--Spacing-Spacing-8, 8px)",
  alignSelf: "stretch",
};
export const drawerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  justifyContent: "flex-start",
};
export const nav = {
  textDecoration: "none",
  display: "flex",
  padding: "8px 0",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
};
export const dropDownContainer = {
  display: "flex",
  width: "180px",
  height: "40px",
  maxWidth: "336.02px",
  padding: "8px 0px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  flexShrink: 0,
};
export const userDropdownRoot = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  flexWrap: "wrap",
};
export const descriptionText = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  letterSpacing: "-0.42px",
};
export const mobileDetailsStyle = {
  centerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "8px",
    maxWidth: "180px",
  },
};
